module.exports = __webpack_public_path__ + "img/pro1.52f5e7cc.png";